import { render, staticRenderFns } from "./PaymentByWireTransfer.vue?vue&type=template&id=2e5409fe&scoped=true&"
import script from "./PaymentByWireTransfer.vue?vue&type=script&lang=js&"
export * from "./PaymentByWireTransfer.vue?vue&type=script&lang=js&"
import style0 from "./PaymentByWireTransfer.vue?vue&type=style&index=0&id=2e5409fe&scoped=true&lang=scss&"
import style1 from "./PaymentByWireTransfer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5409fe",
  null
  
)

export default component.exports